import { mergeDeep } from "@/lib/i18n/mergeDeep";
import type { Locale } from "@/lib/i18n/locales";
import { locales } from "@/lib/i18n/locales";

import { deCatalog } from "./de/bundle";
import { enMessageOverlay } from "./en/bundle";
import { frMessageOverlay } from "./fr/bundle";
import { jaMessageOverlay } from "./ja/bundle";
import { zhMessageOverlay } from "./zh/bundle";

/** Non-DE `landingpages` / `solvingTax` overlays localize marketing copy; `zh` has no `solvingTax.json` and inherits German via mergeDeep. */

export { deCatalog };

export type Messages = Omit<typeof deCatalog, "bghUrteile"> & {
  bghUrteile: (typeof deCatalog)["bghUrteile"] | null;
};

function mergeWithDeCatalog(overlay: Partial<Messages>): Messages {
  return mergeDeep(
    deCatalog as unknown as Record<string, unknown>,
    overlay as Record<string, unknown>,
  ) as Messages;
}

/** Shallow-typed bundle of imported JSON; merged with German catalog via `mergeDeep`. */
function jsonOverlay(bundle: object): Partial<Messages> {
  return bundle as Partial<Messages>;
}

export const messageCatalogs: Record<Locale, Messages> = {
  de: deCatalog as unknown as Messages,
  en: mergeWithDeCatalog(jsonOverlay(enMessageOverlay)),
  fr: mergeWithDeCatalog(jsonOverlay(frMessageOverlay)),
  zh: mergeWithDeCatalog(jsonOverlay(zhMessageOverlay)),
  ja: mergeWithDeCatalog(jsonOverlay(jaMessageOverlay)),
};

export function assertLocalesMatchCatalogs(): void {
  for (const loc of locales) {
    if (!messageCatalogs[loc]) {
      throw new Error(`Missing message catalog for locale: ${loc}`);
    }
  }
}
